export enum DocumentTypesForOrder {
  FILLED_FORM = "filled_form",
  APPROVAL_LETTER = "approval_letter",
  DENIAL_LETTER = "denial_letter",
  NAR_LETTER = "nar_letter",
  AUTH_LETTER = "auth_letter",
  /** A received payer fax that fax intake matched and attached to a pending J-code. */
  FAX_LETTER = "fax_letter",
}

export enum ValidDocumentTypesForUpload {
  APPROVAL_LETTER = "approval_letter",
  DENIAL_LETTER = "denial_letter",
  NAR_LETTER = "nar_letter",
  AUTH_LETTER = "auth_letter",
}
